import  { useEffect, useState } from "react";
import LinearLayout from "../layout/LinearLayout";
import "./HeroSlider.css";

const HeroSlider = ({ images = [], interval = 4000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // حرکت خودکار
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, [images.length, interval]);

  // رفتن به اسلاید قبلی یا بعدی
  const goToSlide = (index) => {
    if (index < 0) index = images.length - 1;
    if (index >= images.length) index = 0;
    setCurrentIndex(index);
  };

  if (images.length === 0) return null;
  console.log("banner",  images[1].image);
  return (
    <LinearLayout
      orientation="vertical"
      width="match-parent"
      height="wrap-content"
      className="hero-slider position-relative"
    >
      {/* تصویر اصلی */}
      <img
        src={`${images[currentIndex].image}`}
        alt={`slide-${currentIndex}`}
        className="hero-image"
         style={{ height: "350px",width:"100%",  }}
      />

      {/* دکمه قبلی/بعدی */}
      <button
        className="slider-btn prev"
        onClick={() => goToSlide(currentIndex - 1)}
      >
        ❮
      </button>
      <button
        className="slider-btn next"
        onClick={() => goToSlide(currentIndex + 1)}
      >
        ❯
      </button>

      {/* نقاط ناوبری */}
      <div className="dots">
        {images.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === currentIndex ? "active" : ""}`}
            onClick={() => goToSlide(idx)}
          ></span>
        ))}
      </div>
    </LinearLayout>
  );
};

export default HeroSlider;
